import { FormStep } from './EasyOnboardingDialog';
import type { AssetTypeTile, BrandTile, TelematicsTile } from './configuration/types';

const UNKNOWN_TRACKING_SEGMENT = 'unknown';

const getLastSegment = (value: string) => {
    const segments = value.split('.');
    return segments[segments.length - 1];
};

const getTelematicsTrackingSegment = (telematics: TelematicsTile | undefined) => {
    if (!telematics) {
        return UNKNOWN_TRACKING_SEGMENT;
    }

    if (telematics.description.includes('.')) {
        return getLastSegment(telematics.description);
    }

    return telematics.displayName.toLowerCase().replaceAll(' ', '-');
};

export const getBrandSelectionTrackingKeyPrefix = (selectedAssetType: AssetTypeTile | undefined) =>
    `easyOnboarding.dialog.choose.asset.${selectedAssetType?.assetType ?? UNKNOWN_TRACKING_SEGMENT}.brand`;

export const getTelematicsSelectionTrackingKeyPrefix = (
    selectedAssetType: AssetTypeTile | undefined,
    selectedBrand: BrandTile | undefined
) =>
    `easyOnboarding.dialog.choose.telematics.asset.${selectedAssetType?.assetType ?? UNKNOWN_TRACKING_SEGMENT}.brand.${
        selectedBrand?.displayName ?? UNKNOWN_TRACKING_SEGMENT
    }`;

export const getTelematicsSelectionTrackingKey = (
    selectedAssetType: AssetTypeTile | undefined,
    selectedBrand: BrandTile | undefined,
    selectedTelematics: TelematicsTile | undefined
) =>
    `${getTelematicsSelectionTrackingKeyPrefix(
        selectedAssetType,
        selectedBrand
    )}.telematics.${getTelematicsTrackingSegment(selectedTelematics)}`;

export const getMissingTelematicTrackingKey = (
    selectedAssetType: AssetTypeTile | undefined,
    selectedBrand: BrandTile | undefined
) => `${getTelematicsSelectionTrackingKeyPrefix(selectedAssetType, selectedBrand)}.missing-telematic`;

export const getSkipToTelematicsTrackingKey = (selectedAssetType: AssetTypeTile | undefined) =>
    `${getBrandSelectionTrackingKeyPrefix(selectedAssetType)}.directly-to-telematics`;

export const getBackButtonTrackingKey = (
    formStep: FormStep,
    selectedAssetType: AssetTypeTile | undefined,
    selectedBrand: BrandTile | undefined
) => {
    if (formStep === FormStep.selectBrand) {
        return `${getBrandSelectionTrackingKeyPrefix(selectedAssetType)}.back`;
    }

    if (formStep === FormStep.selectTelematics) {
        return `${getTelematicsSelectionTrackingKeyPrefix(selectedAssetType, selectedBrand)}.back`;
    }

    return `${UNKNOWN_TRACKING_SEGMENT}.back`;
};
